import type { ClassNameValue } from "tailwind-merge"
import { SponsorIcons } from "./SponsorIcons"

export const SiteFooter = () => {
  return (
    <footer className={`mt-auto bg-slate-800 text-slate-50`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 py-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm opacity-90">© {new Date().getFullYear()} • Created by ADBEx</p>
          {/* <a href="#/terms">Terms</a> */}
          {/* <a href="#">GitHub</a> */}
          {/* <SponsorIcons /> */}
        </div>
      </div>
    </footer>
  )
}
